/* global window */

/**
 * Utility functions for handling base DFP targeting
 */
let Experiments = require('./Experiments');
let SocialReferrer = require('./SocialReferrer');
let PageDepth = require('./PageDepth');

let TargetingPairs = {
  /**
  * Constructs comma delimited targeting list of all the story types tied to a permalink or the story type landing page
  *
  * @param Window scope the window to use for the kinja meta info
  */
	getCategories: function (scope) {
		let categoryMeta = scope.kinja.categoryMeta || {},
			postMeta = scope.kinja.postMeta || {};

		return (postMeta.categories || categoryMeta.categories || '').split(',');
	},

  /**
  * Constructs comma delimited targeting list of all tags tied to a permalink or the tag landing page
  *
  * @param Window scope the window to use for the kinja meta info
  */
	getTags: function (scope) {
		let tagMeta = scope.kinja.tagMeta || scope.kinja.postMeta || {};

		return (tagMeta.tags || '').split(',');
	},

  /**
  * Gets index of article position in reading list
  *
  * @param HTMLElement adContainer the ad container currently being filled
  * @param object kinjaMeta kinja-specific post meta
  */
	getArticlePosition: function (adContainer, kinjaMeta) {
		if (document && adContainer && kinjaMeta.pageType === 'permalink' && !(kinjaMeta.post && kinjaMeta.post.isFeatured)) {
      // Predefined article position
			if (adContainer.dataset.articlePosition) {
				return parseInt(adContainer.dataset.articlePosition);
			}

			let readingListPostIds = Array.from(document.getElementsByClassName('js_reading-list-item')).map(function (post) {
				return post.dataset.postId;
			});

			if (readingListPostIds.length > 0) {
				let readingListItem = adContainer.closest('.js_reading-list-item');
				if (readingListItem) {
					let currentPostId = readingListItem.dataset.postId;
					return readingListPostIds.indexOf(currentPostId) + 2;
				}
			}

      // Starter post
			return 1;
		}

    // Not in reading list
		return 'none';
	},

  /**
   * Constructs associative array of targeting pairs from post meta
   *
   * @param Window scope the window to use for the kinja meta info.
   *
   */
	buildTargetingPairs: function (scope, positionTargeting, adContainer) {
		let kinjaMeta = scope.kinja.meta || {},
			postMeta = scope.kinja.postMeta || {},
			postObject = scope.kinja.postMeta && scope.kinja.postMeta.post ? scope.kinja.postMeta.post : {},
			content = scope.kinja.postContentRatings || [],
			experimentVariation = Experiments.getExperimentVariation(scope),
			experimentId = Experiments.getExperimentId(scope),
			socialTargeting, key,
			targeting = {},
			articlePosition = TargetingPairs.getArticlePosition(adContainer, kinjaMeta),
			postType,
			urlDepth;

      // use kinja's pageType to determine what the postType attribute should be
		switch (kinjaMeta.pageType) {
			case 'permalink':
				if (postObject.qaStatus && postObject.qaStatus !== 'Disabled') {
					postType = 'conversation';
				} else if (postObject.isFeatured) {
					postType = postObject.permalinkRedirect ? 'external' : 'featured';
				} else if (postObject.isVideo) {
					postType = 'video';
				} else if (postObject.discussionSettings && postObject.discussionSettings.mode === 'Liveblog') {
					postType = 'liveblog';
				} else {
					postType = 'article';
				}
				break;
			case 'categoryStream':
				urlDepth = scope.location.pathname.match(/\/.+?/g).length;
				if (urlDepth === 2) {
					postType = 'storytype';
				} else if (urlDepth === 3) {
					postType = 'storytype-category';
				} else if (urlDepth === 4) {
					postType = 'storytype-subcategory';
				}
				break;
			case 'sectionedCategoryStream':
				postType = 'sectioned-storytype';
				break;
			case undefined:
				if (kinjaMeta && kinjaMeta.blog && kinjaMeta.blog.properties && typeof kinjaMeta.blog.properties.isLiveCustomKinja !== 'undefined') {
					postType = 'specialsection';
				}
				break;
			default:
				postType = kinjaMeta.pageType;
				break;
		}
    // Begin slot level params AKA 'scp'
		targeting.slotOptions = {
      // Standard targeting options
			article_position: articlePosition,
			pos: positionTargeting || null,
			postId: postMeta ? postMeta.postId : null,
			socialReferrer: SocialReferrer.getSocialReferrer(),
			page: ((postObject && postObject.sponsored) ? 'sponsored-' : '') + (postType || 'none'),
			pd: PageDepth.getPageDepth(),
			mtfIFPath: '\/assets\/vendor\/doubleclick\/'
		};
    // Begin page level targeting pairs AKA cust_params
		targeting.pageOptions = {
			tags: this.getTags(scope),
			category: this.getCategories(scope),
			blogName: (kinjaMeta.blog || {}).name
		};

		if (experimentVariation !== null && experimentId !== null && positionTargeting) {
			targeting.slotOptions.exp_variation = experimentId + '_' + experimentVariation + '_' + positionTargeting;
			targeting.slotOptions.exp_id = experimentId;
			targeting.slotOptions.exp_var = experimentVariation;
		}

		return targeting;
	},

  /**
   * Constructs associative array of targeting pairs
   *
   * @param string forcedAdZone forced ad zone, if any
   * @param Window scope the window to use for the kinja meta info.
   * @param element adContainer optional ad container to determine positioning
   *
   */
	getTargetingPairs: function (forcedAdZone, positionTargeting, adContainer) {
		if (forcedAdZone && !window.kinja) {
			return { pageOptions: { forcedAdZone: forcedAdZone} };
		}
		if (!window.kinja) {
			return {};
		}

		let targetingOptions = this.buildTargetingPairs(window, positionTargeting, adContainer);

		targetingOptions.pageOptions.forcedAdZone = forcedAdZone || false;

		return targetingOptions;
	}
};
module.exports = TargetingPairs;



// WEBPACK FOOTER //
// ./theroot/root-100-2019/bulbs-public-ads-manager/src/helpers/TargetingPairs.js